import { MouseEventHandler, ReactNode } from "react"
import { makeStyles } from "tss-react/mui"

import { StandardButton } from "./StandardButton"

const useStyles = makeStyles()((theme) => ({
    button: {
        flexShrink: 0,
        whiteSpace: "nowrap",
        "&.MuiButton-root": {
            height: "3rem",
            padding: ".5rem .875rem",
            borderRadius: ".5rem",
            border: `1px solid ${theme.palette.tailwind.blue[200]}`,
            background: theme.palette.tailwind.blue[50],
            color: theme.palette.primary.main,
            fontSize: ".875rem",
            fontWeight: 700,
        },
    },
}))

type Props = Readonly<{
    onClick: MouseEventHandler<HTMLButtonElement>
    startIcon?: ReactNode
    children: ReactNode
    className?: string
}>

export function StandardLightBlueButton({ onClick, startIcon, children, className }: Props) {
    const { classes, cx } = useStyles()

    return (
        <StandardButton
            variant="text"
            size="small"
            fullWidth={false}
            type="button"
            className={cx(classes.button, className)}
            startIcon={startIcon}
            onClick={onClick}
        >
            {children}
        </StandardButton>
    )
}
